import Styled from 'styled-components';

const NekoMessageDanger = Styled.p`
  background: #ba341e;
  padding: 20px;
  color: white;
  border-radius: 10px;
  font-size: 15px;

  a {
    color: white;
    font-weight: bold;
  }
`;

const NekoMessageSuccess = Styled.p`
  background: #1eba96;
  padding: 20px;
  color: white;
  border-radius: 10px;
  font-size: 15px;
  text-align: center;

  a {
    color: white;
    font-weight: bold;
  }
`;

export { NekoMessageDanger, NekoMessageSuccess };